import { render } from "./ServicesSection.vue?vue&type=template&id=3c0e8905&scoped=true"
import script from "./ServicesSection.vue?vue&type=script&lang=js"
export * from "./ServicesSection.vue?vue&type=script&lang=js"

import "./ServicesSection.vue?vue&type=style&index=0&id=3c0e8905&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_3fde62ecf17df48f63b2288f8ccd725b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c0e8905"]])

export default __exports__